'use client';

import Link from '@eliadmin/core/src/components/link';
import { Icon } from '@eliadmin/core/src/components/dlz/ui/icon';
import { REVIEW_COPY } from '@eliadmin/core/src/components/dlz/product-detail/reviews/review-copy';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

/** Figma „CTA · Login required“ (60137:8962): shown to guests, who cannot post a review. */
export function ReviewSignInCard() {
  const { t } = useTranslations();

  return (
    <div className="grid grid-cols-[52px_1fr] items-center gap-x-3 rounded-[18px] border border-[#E2E4E7] bg-white p-4 md:grid-cols-1 md:items-start md:p-6">
      <span
        aria-hidden="true"
        className="flex size-[52px] items-center justify-center rounded-full bg-[#F5F6F7] text-[#D7191F]"
      >
        <Icon name="user" size={24} />
      </span>
      <h3 className="dlz-h4 text-[#0F1012] md:mt-4">{REVIEW_COPY.signIn.title}</h3>
      <p className="dlz-body-s col-span-2 mt-3 text-[#4F545C] md:col-span-1">
        {REVIEW_COPY.signIn.text}
      </p>
      <div className="col-span-2 mt-4 flex flex-col gap-2 md:col-span-1 md:gap-3">
        <Button asChild className="h-12 w-full md:h-[52px]">
          <Link href={ROUTES.PROFILE()} prefetch={false}>
            {REVIEW_COPY.signIn.action}
          </Link>
        </Button>
        <Button asChild variant="secondary" className="h-12 w-full md:h-[52px]">
          <Link href={ROUTES.REGISTER()} prefetch={false}>
            {t('text758')}
          </Link>
        </Button>
      </div>
    </div>
  );
}
